import React, { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import ConditionalRender, {
  Experiment,
  Original
} from '@/components/ConditionalRender'
import { AppDownloadBannerContentType } from './types'
import { getPropsForAppBanner } from './utils'
import useAppBanner from './useAppBanner'
import AppBanner from './AppBanner'
import AppBannerExperiment from './AppBannerExperiment/AppBannerExperiment'

const AppBannerWrapper = ({
  content,
  ...props
}: {
  content: AppDownloadBannerContentType
} & Record<string, unknown>) => {
  const showAppBanner = useAppBanner()
  const bootstrapData = useContext(BootstrapDataContext)

  return showAppBanner ? (
    <ConditionalRender experimentCode="MBL_HP_APP_BANNER_REDESIGN">
      <Original>
        <AppBanner
          {...{
            ...getPropsForAppBanner(bootstrapData),
            ...content,
            ...props
          }}
        />
      </Original>
      <Experiment>
        <AppBannerExperiment
          {...{
            ...getPropsForAppBanner(bootstrapData),
            ...content,
            ...props
          }}
        />
      </Experiment>
    </ConditionalRender>
  ) : null
}

export default AppBannerWrapper
